module.exports = __webpack_public_path__ + "static/assets/23e14c627a50515a86f7b54de6be96f1.png";